import script from "./SiteSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteSidebar.vue?vue&type=script&setup=true&lang=js"

import "./SiteSidebar.vue?vue&type=style&index=0&id=1dc32540&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc32540"]])

export default __exports__